<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dcpnAD/tc-custom/9780226905693.jpg?1733032716292" alt="This image is the cover for the book In Hock"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In Hock
      </h1>
      <p class="bookDescription body article font2">
        <p>The definitive history of pawnbroking in the United States from the nation’s founding through the Great Depression, <i>In Hock</i> demonstrates that the pawnshop was essential to the rise of capitalism. The class of working poor created by this economic tide could make ends meet only, Wendy Woloson argues, by regularly pawning household objects to supplement inadequate wages. Nonetheless, businessmen, reformers, and cultural critics claimed that pawnshops promoted vice, and employed anti-Semitic stereotypes to cast their proprietors as greedy and cold-hearted. Using personal correspondence, business records, and other rich archival sources to uncover the truth behind the rhetoric, Woloson brings to life a diverse cast of characters and shows that pawnbrokers were in fact shrewd businessmen, often from humble origins, who possessed sophisticated knowledge of a wide range of goods in various resale markets.            A much-needed new look at a misunderstood institution, <i>In Hock</i> is both a first-rate academic study of a largely ignored facet of the capitalist economy and a resonant portrait of the economic struggles of generations of Americans.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wendy A. Woloson
      </h2>
      
      <p class="authorDescription body article"><P><B>Wendy Woloson</B> is an independent scholar and consulting historian living in Philadelphia. She is the author of <I>Refined Tastes: Sugar, Consumers, and Confectionery in Nineteenth-Century American Culture</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e8e8c0c